import CurrencyCell from '@/components/Reports/Cell/CurrencyCell.vue'

const config = {
  cellRenderer: CurrencyCell
}
export default {
  type: 'Currency',
  config
}
